import _styled, { default as _styled2, default as _styled3, default as _styled4, default as _styled5 } from "styled-components";
import React from "react";
import { useCopyToClipboard } from "react-use";
import { getThemeStyle } from "~/features/ui/get-theme-style";
import { Wrap } from "~/features/ui/wrap";
import { composeLinkedinUrl, composeXUrl } from "~/features/social-share/utils";
import { IconButton } from "~/features/ui/icon-button";
import Linkedin from "~/public/icons/linkedin.svg";
import X from "~/public/icons/x.svg";
import Checkmark from "~/public/icons/checkmark.svg";
import LinkIcon from "~/public/icons/link.svg";
type SocialShareBlockViewProps = {
  anchor?: Array<{
    id?: string | null;
    name?: string | null;
  }> | {
    id?: string | null;
    name?: string | null;
  } | null;
  hasTopDivider?: boolean | null;
  sectionProps?: React.ComponentPropsWithoutRef<"section"> & Record<`data-${string}`, string | undefined>;
  text?: string | null;
};
export function SocialShareBlockView({
  anchor,
  hasTopDivider = true,
  sectionProps,
  text
}: SocialShareBlockViewProps) {
  const themeStyle = getThemeStyle({
    mode: "light"
  });
  const [copiedState, copyToClipboard] = useCopyToClipboard();
  const [showCopiedStatus, setShowCopiedStatus] = React.useState(false);
  React.useEffect(() => {
    if (copiedState.value) {
      setShowCopiedStatus(true);
      setTimeout(() => {
        setShowCopiedStatus(false);
        copiedState.value = undefined;
      }, 2000);
    }
  }, [copiedState]);
  return <_StyledSection {...sectionProps} id={Array.isArray(anchor) ? anchor[0]?.id || undefined : anchor?.id || undefined} data-anchor-name={Array.isArray(anchor) ? anchor[0]?.name || undefined : anchor?.name || undefined} $_css={[hasTopDivider && {
    "borderTopWidth": "1px"
  }, themeStyle.background, themeStyle.border, themeStyle.text]}>
      <Wrap mode="light">
        <_StyledDiv>
          <_StyledDiv2 $_css2={[{
          "position": "relative",
          "zIndex": "10",
          "display": "flex",
          "alignItems": "center",
          "justifyContent": "center",
          "columnGap": "1.6rem",
          "paddingTop": "4rem",
          "paddingBottom": "4rem",
          "@media (min-width: 1024px)": {
            "borderLeftWidth": "1px",
            "borderRightWidth": "1px"
          }
        }, themeStyle.background, themeStyle.border]}>
            <_StyledP>
              {text || "Share this page"}
            </_StyledP>
            <_StyledDiv3>
              <IconButton onClick={() => window.open(composeLinkedinUrl(window.location.href))} icon={{
              component: Linkedin,
              size: "24"
            }} size="medium" />
              <IconButton onClick={() => window.open(composeXUrl(window.location.href))} icon={{
              component: X,
              size: "24"
            }} size="medium" />
              <IconButton onClick={() => copyToClipboard(window.location.href)} icon={{
              component: showCopiedStatus ? Checkmark : LinkIcon,
              size: "16"
            }} size="medium" />
            </_StyledDiv3>
          </_StyledDiv2>
        </_StyledDiv>
      </Wrap>
    </_StyledSection>;
}
var _StyledSection = /*#__PURE__*/_styled("section").withConfig({
  componentId: "sc-sf-ztim6l-0"
})`${p => p.$_css}`;
var _StyledDiv = _styled2("div").withConfig({
  componentId: "sc-sf-ztim6l-1"
})({
  "@media (min-width: 1024px)": {
    "paddingLeft": "4rem",
    "paddingRight": "4rem"
  }
});
var _StyledDiv2 = _styled3("div").withConfig({
  componentId: "sc-sf-ztim6l-2"
})`${p => p.$_css2}`;
var _StyledP = _styled4("p").withConfig({
  componentId: "sc-sf-ztim6l-3"
})({
  "fontFamily": "Aeonik, ui-serif, Georgia, Cambria, \"Times New Roman\", Times, serif",
  "fontSize": "1.4rem",
  "lineHeight": "1.1",
  "letterSpacing": "0.028000000000000004rem",
  "fontWeight": "400",
  "@media (min-width: 1024px)": {
    "fontSize": "1.6rem",
    "lineHeight": "1.1",
    "letterSpacing": "0.032rem",
    "fontWeight": "400"
  }
});
var _StyledDiv3 = /*#__PURE__*/_styled5("div").withConfig({
  displayName: "social-share___StyledDiv3",
  componentId: "sc-1wab0bn-0"
})({
  "display": "flex",
  "columnGap": "0.8rem"
});